// Debounced club-search analytics for Home: once the results for a non-empty
// query have settled for 800 ms, report them once (services/clubAnalyticsService
// dedupes per query, so club pages streaming in later do not re-fire).
import { useEffect } from "react";
import { trackClubSearchResults } from "../services/clubAnalyticsService";

const SETTLE_MS = 800;

export default function useClubSearchTracking(searchQuery, results) {
  useEffect(() => {
    if (!searchQuery.trim()) return undefined;
    const t = setTimeout(() => trackClubSearchResults(results.map((c) => c.id), searchQuery), SETTLE_MS);
    return () => clearTimeout(t);
  }, [searchQuery, results]);
}
